import { render, staticRenderFns } from "./SelectLibraryObjectModal.vue?vue&type=template&id=25fceb37"
import script from "./SelectLibraryObjectModal.vue?vue&type=script&lang=ts"
export * from "./SelectLibraryObjectModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectLibraryObjectModal.vue?vue&type=style&index=0&id=25fceb37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports